// Design tokens untuk halaman-halaman baru SM Media (Artists, Campaigns, Analytics, dst)
// Base: tema gelap yang sudah dipakai SM Media (navy + gold), BUKAN tema terang baru Eighteen Media —
// supaya visual SM Media tetap konsisten dengan yang sudah ada. Nama token sengaja sama persis
// dengan versi Eighteen Media supaya komponen bisa di-port tanpa ubah logic, cuma beda nilai warna.

export const colors = {
  bgPage: '#0a0e1a',
  bgCard: '#111827',
  bgCardMuted: '#1a2235',
  border: '#1e2d45',
  borderStrong: '#2d3f5f',

  textPrimary: '#f1f5f9',
  textSecondary: '#94a3b8',
  textMuted: '#64748b',

  accent: '#f59e0b',
  accentMuted: '#451a03',
  accentText: '#fbbf24',

  gold: '#f59e0b',
  goldMuted: '#451a03',
  goldText: '#fbbf24',

  success: '#10b981',
  successMuted: '#064e3b',
  warning: '#f59e0b',
  warningMuted: '#451a03',
  danger: '#ef4444',
  dangerMuted: '#450a0a',
};

export const radius = {
  sm: '8px',
  md: '10px',
  lg: '12px',
};

export const shadow = {
  card: '0 1px 2px rgba(0,0,0,0.3)',
};

export const styles = {
  page: {
    background: colors.bgPage,
    minHeight: '100vh',
    color: colors.textPrimary,
  },
  card: {
    background: colors.bgCard,
    border: `1px solid ${colors.border}`,
    borderRadius: radius.lg,
    padding: '20px',
    boxShadow: shadow.card,
  },
  cardMuted: {
    background: colors.bgCardMuted,
    borderRadius: radius.md,
    padding: '16px',
  },
  buttonPrimary: {
    background: `linear-gradient(135deg, ${colors.gold}, ${colors.accentText})`,
    color: '#000000',
    border: 'none',
    borderRadius: radius.sm,
    padding: '10px 18px',
    fontSize: '13px',
    fontWeight: 700,
    cursor: 'pointer',
  },
  buttonSecondary: {
    background: colors.bgCard,
    color: colors.textPrimary,
    border: `1px solid ${colors.borderStrong}`,
    borderRadius: radius.sm,
    padding: '10px 18px',
    fontSize: '13px',
    fontWeight: 600,
    cursor: 'pointer',
  },
  badgeSuccess: {
    background: colors.successMuted,
    color: colors.success,
    fontSize: '12px',
    fontWeight: 600,
    padding: '4px 10px',
    borderRadius: '20px',
  },
  badgeWarning: {
    background: colors.warningMuted,
    color: colors.warning,
    fontSize: '12px',
    fontWeight: 600,
    padding: '4px 10px',
    borderRadius: '20px',
  },
  badgeDanger: {
    background: colors.dangerMuted,
    color: colors.danger,
    fontSize: '12px',
    fontWeight: 600,
    padding: '4px 10px',
    borderRadius: '20px',
  },
};
